import React from "react";
import { useStats } from "@/context/StatsContext";

// Compacte "Live HH:MM"-indicator met groen bolletje, herbruikt in beide werkbalken (kaart + planning).
export function LiveIndicator({ className = "" }) {
  const { updatedAt, reload } = useStats();
  return (
    <button type="button" onClick={reload} data-testid="kpi-refresh"
      className={`flex items-center gap-1.5 text-[11px] text-muted-foreground hover:text-foreground transition-colors duration-150 ${className}`}>
      <span className="live-dot" />
      Live {updatedAt ? new Date(updatedAt).toLocaleTimeString().slice(0, 5) : "—"}
    </button>
  );
}
